import Blue from "~/core";

new Blue({
	name: 'Supplier Info - Main Mobile Accordions',
	selector: ".supplier-info",
	setup(component) {
		const containers = [...component.querySelectorAll(".supplier-info__topic, .supplier-info__blog-section, .supplier-info__service-wrapper")];
		let toggles = [];
		const breakpoint = 576;
		let currentWindowWidth = window.innerWidth;
		let toggleCondition;

		containers.forEach(container => {
			let trigger;
			let content;
			if (container.matches(".supplier-info__topic")) {
				trigger = container.querySelector(".supplier-info__topic-toggle");
				content = container.querySelector(".supplier-info__topic-content");
			} else if (container.matches(".supplier-info__blog-section")) {
				trigger = container.querySelector(".supplier-info__blog-toggle");
				content = container.querySelector(".supplier-info__blog-content");
			} else if (container.matches(".supplier-info__service-wrapper")) {
				trigger = container.querySelector(".supplier-info__service-heading");
				content = container.querySelector(".supplier-info__service-content");
			}
			toggleCondition = () => !container.matches(".on-desktop");
			let config = {
				container,
				trigger,
				content,
				toggleCondition,
			};
			toggles.push(new this.$toggle(config));
		});

		const applyDesktopFunctions = () => {
			toggles.forEach(t => {t.toggle()});
			containers.forEach(c => {
				c.classList.add("on-desktop");
				if (c.matches(".supplier-info__service-wrapper")) {
					let trigger = c.querySelector(".supplier-info__service-heading");
					trigger.setAttribute("role", "link");
				}
			});
		}

		const applyMobileFunctions = () => {
			containers.forEach(c => {
				c.classList.remove("on-desktop");
				if (c.matches(".supplier-info__service-wrapper")) {
					let trigger = c.querySelector(".supplier-info__service-heading");
					trigger.setAttribute("role", "button");
				}
			});
			toggles.forEach(t => {t.close()});
		}

		if (currentWindowWidth > breakpoint) applyDesktopFunctions();

		containers.forEach(c => {
			if (c.matches(".supplier-info__service-wrapper")) {
				let trigger = c.querySelector(".supplier-info__service-heading");
				this.$addEvents(trigger, "click.prevent, enter.prevent", () => {
					if (!!trigger.closest(".on-desktop") || currentWindowWidth > breakpoint) { // in desktop, heading links should work as links; in mobile, they should only be accordion triggers
						window.location.href = trigger.getAttribute("href");
					}
				});
			}
		});

		// if window resize passes md breakpoint in either direction, close accordion
		this.$addEvents(window, "resize", () => {
			let newWindowWidth = window.innerWidth;
			if (currentWindowWidth <= breakpoint && newWindowWidth > breakpoint) applyDesktopFunctions()
			if (currentWindowWidth > breakpoint && newWindowWidth <= breakpoint) applyMobileFunctions();
			currentWindowWidth = newWindowWidth;
		});
	}
});
